/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 771:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const React = __webpack_require__(15);

/**
 * I18nContext
 * Saves the I18n instance that is used by the provider
 */
const I18nContext = React.createContext({});

/**
 * useI18n
 * Hook to access the i18n context
 */
const useI18n = () => React.useContext(I18nContext);

/**
 * Expose I18nContext
 */
module.exports = {
  I18nContext,
  useI18n
};

/***/ }),

/***/ 155:
/***/ ((module, exports, __webpack_require__) => {

var _objectSpread = (__webpack_require__(384)["default"]);
var _reactJsxRuntime = __webpack_require__(732);
var _jsx = (__webpack_require__(971)["default"]);
/**
 * Module dependencies
 */
const React = __webpack_require__(15);
const {
  I18nContext,
  useI18n
} = __webpack_require__(771);

/**
 * I18nProvider
 */
const I18nProvider = _ref => {
  let {
    children,
    i18n
  } = _ref;
  return /*#__PURE__*/_jsx(I18nContext.Provider, {
    value: {
      i18n
    }
  }, void 0, React.Children.only(children));
};
const injectI18n = Component => {
  const InjectI18n = props => {
    const i18n = useI18n();
    return /*#__PURE__*/_reactJsxRuntime.jsx(Component, _objectSpread(_objectSpread({}, props), i18n));
  };
  return InjectI18n;
};

/**
 * propTypes
 */

/**
 * Expose I18nProvider
 */
module.exports = I18nProvider;
exports = module.exports;
exports.I18nProvider = I18nProvider;
exports.injectI18n = injectI18n;
exports.I18nContext = I18nContext;
exports.useI18n = useI18n;

/***/ }),

/***/ 971:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 384:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectSpread2");

/***/ }),

/***/ 15:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 732:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(155);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;